import { useSelector } from "react-redux";
import { MdVerified } from "react-icons/md";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { IoIosInformationCircle } from "react-icons/io";
import { Box, Grid, Tooltip, Typography, Paper, Divider } from "@mui/material";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ImagePopup from "./ImagePopup";
import { useAxios } from "../../hooks";
import convertDate from "../../utils/convertDate";
import LoadingButton from "../../components/LoadingButton";
import { Fragment } from "react";
import UserDetailPopUp from "./UserDetailPopUp";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";
import Color from "../../theme/color";

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  min-height: 75vh;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 17px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Box)`
  width: 100%;
  border-radius: 15px;
  // min-height: 50vh;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
`;

const TableCells = styled(TableCell)``;

export default function AppointmentSummary() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { eventID } = useParams();
  const { state, search } = useLocation();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [userDetial, setUserDetial] = useState([]);
  const [userDetialPopUp, setUserDetialPopUp] = useState(false);

  const queryParams = new URLSearchParams(search);

  const entityID = queryParams.get("entity_id");
  const visitorID = queryParams.get("visitor_id");
  const bookingID = queryParams.get("booking_id");
  const userTypeId = queryParams.get("user_type_id");
  const digiLockerID = queryParams.get("id");

  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState(state);

  const userPayloadString = localStorage.getItem(
    `userPayload_${visitorData.ID}`
  );

  const userPayload = JSON.parse(userPayloadString);

  let localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorData.ID) && !item.includes("userPayload");
  });

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });
    if (digiLockerID) {
      axios({
        url: "event/govt-api/get-user-document",
        method: "POST",
        data: {
          document_type: "aadhar",
          request_id: digiLockerID,
          visitor_id: visitorData.ID,
          document_verification: true,
          is_encrypted_face: true,
          face_data: localStorage.getItem(faceData[0]),
        },
      }).then((response) => {
        if (response.status) {
          let key = visitorData.ID;
          localStorage.setItem(key, response.data.encrypted_face_data);
        }
      });
    }
  }, []);

  useEffect(() => {
    let url = "admin/profile/get-visitor-booking-status";

    let method = "POST";

    let data = {
      visitor_id: visitorID,
      entity_id: entityID,
      user_type_id: userTypeId,
      booking_id: bookingID,
      face_data: getVisitorFaceData(visitorID),
    };

    axios({
      url: url,
      disableRedirect: true,
      method: method,
      data: data,
    }).then((response) => {
      if (response.status) {
        setUserData({ userData: response.data });
      }
    });
  }, [axios, eventID]);

  const renderInfoItem = (label, value) => (
    <TableRow>
      <TableCells sx={{ width: "40%" }}>
        <Typography
          variant="body1"
          style={{ color: "rgb(150 150 150)" }}
          fontWeight={900}
        >
          {label}
        </Typography>
      </TableCells>
      <TableCells sx={{ width: "60%", textAlign: "center" }}>
        <Tooltip title={value}>
          <Typography
            variant="h6"
            fontWeight={900}
            sx={{
              color: value === "pending" ? "red" : "black",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {value?.toUpperCase()}
          </Typography>
        </Tooltip>
      </TableCells>
    </TableRow>
  );

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="start"
      // minHeight="100vh"
      marginTop={4}
      paddingBottom={2}
      sx={{ backgroundColor: "#ffffffff" }}
    >
      <Paper
        elevation={4}
        sx={{
          borderRadius: "16px",
          padding: 3,
          width: { xs: "90%", md: "480px" },
          textAlign: "center",
        }}
      >
        {/* Banner */}
        <Box
          component="img"
          src={
            userData?.userData[0]?.premises_image ||
            "data:image/png;base64,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"
          }
          alt="Event Banner"
          sx={{
            width: "100%",
            borderRadius: "12px",
            boxShadow: 2,
            mb: 3,
          }}
        />

        {/* Title */}
        {userData?.userData[0]?.journey_status?.user_status == "" ? (
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            🎉 Congratulations
          </Typography>
        ) : (
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Kindly Complete Process
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" mb={2}>
          {userData?.userData[0]?.appointment_status != "pending"
            ? `Your appointment has been approved. Please visit ${userData?.userData[0]?.premises_name} at the scheduled time.`
            : userData?.userData[0]?.journey_status?.user_status == ""
            ? `Your appointment request has been successfully submitted. Approval is pending, and you will be notified via email or WhatsApp once it is confirmed.`
            : `Your registration for ${userData?.userData[0]?.premises_name} is complete. Please proceed with the next steps.`}
        </Typography>
        {/* Booking Details */}
        {userData?.userData?.map((item, index) => {
          return (
            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "12px",
                p: 2,
                mb: 3,
                backgroundColor: "#FAFAFA",
              }}
            >
              <Typography
                variant="subtitle2"
                color="text.secondary"
                mb={1}
                textAlign="left"
              >
                #{`${index + 1}`} Booking Details
              </Typography>
              <Divider />

              <Grid container alignItems="center" mt={2}>
                <Grid item xs={9} textAlign="left" mb={2}>
                  <Typography variant="body1" fontWeight="bold">
                    {userData?.userData[index]?.visitor_info?.first_name +
                      " " +
                      userData?.userData[index]?.visitor_info?.last_name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Booking ID: {userData?.userData[index]?.appointment_id}
                  </Typography>
                  <br />
                  <Typography variant="caption" color="text.secondary">
                    Officer Name: {userData?.userData[index]?.officer_name}
                  </Typography>
                </Grid>
                {console.log(
                  userData?.userData[index]?.journey_status?.user_status,
                  "EFFWEF"
                )}

                <Grid item xs={3} textAlign="right" mb={2}>
                  {userData?.userData[index]?.journey_status?.user_status ==
                    "Verify" ||
                  userData?.userData[index]?.journey_status?.user_status ==
                    "Add member" ? (
                    <NewReleasesIcon
                      size={28}
                      // color="red"
                      sx={{ color: "red" }}
                    />
                  ) : (
                    <MdVerified size={28} color="green" />
                  )}
                </Grid>
                {userData?.userData[index]?.journey_status?.user_status !=
                  "" && (
                  <Grid item xs={12}>
                    <LoadingButton
                      size="small"
                      variant="outlined"
                      onClick={() =>
                        navigate(
                          userData?.userData[index]?.journey_status?.page_link
                        )
                      }
                      disabled={
                        (!userData?.userData[index]?.visitor_info
                          ?.is_dependent &&
                          userData?.userData[index]?.user_type ==
                            "secondary") ||
                        !userData?.userData[index]?.visitor_info?.first_name
                      }
                      style={{
                        fontSize: "12px",
                        padding: "2px",
                        border: `1px solid ${Color.digipass}`,
                        color: Color.digipass,
                      }}
                      backgroundColor={"white"}
                    >
                      {userData?.userData[index]?.journey_status?.user_status
                        .toUpperCase()
                        .replace("_", " ")}
                    </LoadingButton>
                  </Grid>
                )}
              </Grid>
            </Paper>
          );
        })}

        {/* Instructions */}
        <Box textAlign="left" mb={3}>
          {/* <Typography variant="body2" mb={1}>
            ✅ Please reach the Venue 1 Hour before the event time.
          </Typography> */}
        </Box>
        {/* Footer */}
        <Box
          sx={{
            backgroundColor: "#F0F7FF",
            borderRadius: "8px",
            p: 2,
          }}
        >
          <Typography variant="body2" fontWeight="bold">
            ✨ You will also be informed about next steps via Email and WhatsApp
            ✨
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
